import { createServerOnlyFn } from "@tanstack/react-start";
import { createContactSession } from "./contact-sessions-handler.server";

const handleContactSession = createServerOnlyFn((input: { request: Request }) =>
    createContactSession(input),
);

export const contactSessionsRoute = {
    server: { handlers: { POST: handleContactSession } },
};
